export default __webpack_public_path__ + "static/Step-7-001d6c882a935302fbf804cceda9d65b.svg";